import { Grid, Card, CardContent, Typography, Box, Chip, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { Router as RouterIcon, CloudDone as CloudDoneIcon, People as PeopleIcon, SwapVert as SwapVertIcon } from '@mui/icons-material';
import { useNodes } from '../hooks/useNodes';
import type { NodeResponse } from '../api/types';

function StatCard({ title, value, icon, color }: { title: string; value: string | number; icon: React.ReactNode; color: string }) {
  return (
    <Card>
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <Box>
            <Typography variant="body2" color="text.secondary">{title}</Typography>
            <Typography variant="h4" fontWeight={700} sx={{ mt: 1 }}>{value}</Typography>
          </Box>
          <Box sx={{ bgcolor: color, borderRadius: 2, p: 1, color: '#fff' }}>{icon}</Box>
        </Box>
      </CardContent>
    </Card>
  );
}

export function DashboardPage() {
  const { data: nodes, isLoading } = useNodes();

  const totalNodes = nodes?.length || 0;
  const activeNodes = nodes?.filter(n => n.isActive).length || 0;

  return (
    <Box>
      <Typography variant="h5" fontWeight={600} sx={{ mb: 3 }}>仪表盘</Typography>

      <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard title="节点总数" value={totalNodes} icon={<RouterIcon />} color="#1976d2" />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard title="在线节点" value={activeNodes} icon={<CloudDoneIcon />} color="#4caf50" />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard title="活跃用户" value="—" icon={<PeopleIcon />} color="#ff9800" />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard title="今日流量" value="—" icon={<SwapVertIcon />} color="#9c27b0" />
        </Grid>
      </Grid>

      <Typography variant="h6" fontWeight={600} sx={{ mb: 2 }}>节点状态</Typography>
      <TableContainer component={Paper} variant="outlined">
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>节点名称</TableCell>
              <TableCell>协议</TableCell>
              <TableCell>地址</TableCell>
              <TableCell>状态</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {nodes?.slice(0, 10).map((node: NodeResponse) => (
              <TableRow key={node.id}>
                <TableCell>{node.name}</TableCell>
                <TableCell><Chip label={node.protocol.toUpperCase()} size="small" variant="outlined" /></TableCell>
                <TableCell>{node.address}:{node.port}</TableCell>
                <TableCell>
                  <Chip
                    label={node.isActive ? '启用' : '禁用'}
                    size="small"
                    color={node.isActive ? 'success' : 'default'}
                  />
                </TableCell>
              </TableRow>
            ))}
            {(!nodes || nodes.length === 0) && (
              <TableRow>
                <TableCell colSpan={4} align="center" sx={{ py: 3, color: 'text.secondary' }}>
                  暂无节点，请在"节点管理"中添加
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
